var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint global-require: 0 */
import { Component, Vue, } from 'vue-property-decorator';
import authService from '../services/auth';
var LandingPage = /** @class */ (function (_super) {
    __extends(LandingPage, _super);
    function LandingPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.authenticated = false;
        _this.medialinks = [{
                title: 'Announcing VoterPeer from BU',
                url: 'https://read.cash/@Bitcoin-Unlimited/announcing-votepeer-from-bu-767d16a3',
            },
            {
                title: 'Bitcoin.com: Bitcoin Unlimited Launches Two-Option Voting App Powered by Bitcoin Cash',
                url: 'https://news.bitcoin.com/bitcoin-unlimited-launches-two-option-voting-app-powered-by-bitcoin-cash/',
            },
            {
                title: 'Reddit thread',
                url: 'https://old.reddit.com/r/btc/comments/itvski/announcing_votepeer_from_bu_decentralised_voting/',
            },
            {
                title: 'Unlimit Podcast - VotePeer: Decentralised, censorship-resistant voting',
                url: 'https://www.youtube.com/watch?v=_MXrg3Ac8Ts',
            },
            {
                title: 'VotePeer — A call For Testers',
                url: 'https://bitcoinunlimit.medium.com/votepeer-a-call-for-testers-a0686c89ce6e',
            }];
        _this.screenshotsWebsite = [{
                src: require('../assets/screenshots/website-new-election.png'),
                alt: 'Creating a new election',
            },
            {
                src: require('../assets/screenshots/website-election-details.png'),
                alt: 'Election details',
            },
            {
                src: require('../assets/screenshots/website-election-list.png'),
                alt: 'Election overview',
            },
            {
                src: require('../assets/screenshots/website-groups.png'),
                alt: 'User groups',
            },
        ];
        _this.screenshotsAndroid = [{
                src: require('../assets/screenshots/android-election-list.png'),
                alt: 'List of elections in App',
            },
            {
                src: require('../assets/screenshots/android-submit-vote.png'),
                alt: 'Casting a vote in App',
            },
            {
                src: require('../assets/screenshots/android-identity.png'),
                alt: 'User account is a Bitcoin Cash address',
            },
        ];
        return _this;
    }
    LandingPage.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                authService.observeAuth()
                    .subscribe(function (currentUser) {
                    var isAnonymous = currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous;
                    _this.authenticated = currentUser != null && !isAnonymous;
                });
                return [2 /*return*/];
            });
        });
    };
    LandingPage.prototype.scrollMeTo = function (refName) {
        var element = this.$refs[refName];
        var top = element.offsetTop;
        window.scrollTo({
            top: top,
            left: 0,
            behavior: 'smooth',
        });
    };
    LandingPage = __decorate([
        Component
    ], LandingPage);
    return LandingPage;
}(Vue));
export default LandingPage;
